export default __webpack_public_path__ + "static/media/icon_5.9fa8d683.png";